export default {"src":"/_next/static/media/avatar.c27e986f.svg","height":40,"width":40};